
export const SUBMIT_BOOKS_SEARCH = 'search/SUBMIT_BOOKS_SEARCH';
export const SUBMIT_CHAPTERS_SEARCH = 'search/SUBMIT_CHAPTERS_SEARCH';
export const SUBMIT_QUESTIONS_SEARCH = 'search/SUBMIT_QUESTIONS_SEARCH';